<template>
  <div class="card">
    <div class="card-body">
      <div class="row" v-if="user != null">
        <div class="col text-left">
          <div class="row">
            <div class="col">
              <span class="widget_value text-bold">
                R${{ transfer.data.value.toFixed(2) }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="text-bold" v-if="user.uid == transfer.data.send">
                Para:
                <span class="text-normal">{{ transfer.data.receipt_name.toUpperCase() }}</span>
              </span>
              <span class="text-bold" v-if="user.uid == transfer.data.receipt">
                De:
                <span class="text-normal">{{ transfer.data.send_name.toUpperCase() }}</span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span
                class="text-bold"
                v-if="user.uid == transfer.data.send"
              >{{ transfer.data.receipt_phone }}</span>
              <span
                class="text-bold"
                v-if="user.uid == transfer.data.receipt"
              >{{ transfer.data.send_phone }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-auto">
          <div class="row">
            <div class="col aling-center">{{ fthour }}</div>
          </div>
          <div class="row">
            <div class="col aling-center">{{ ftdate }}</div>
          </div>
        </div>
        <div class="col-md-auto">
          <span
            class="text-bold"
            v-if="user.uid == transfer.data.send"
          >Enviada</span>
          <span
            class="text-bold"
            v-if="user.uid == transfer.data.receipt"
          >Recebida</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "Destiny",
  props: {
    transfer: Object
  },
  data() {
    return {};
  },
  computed: {
    fthour: function() {
      try {
        return moment(this.transfer.data.dates.create).format("HH:mm");
      } catch (e) {
        //console.log(e);
        return "--:--";
      }
    },
    ftdate: function() {
      try {
        return moment(this.transfer.data.dates.create).format("DD/MM/YYYY");
      } catch (e) {
        //console.log(e);
        return "--/--/----";
      }
    },
    user: function() {
      return this.$root.user;
    }
  }
};
</script>

<style>
.widget_value{
  font-size: 20pt;
}
</style>